import React, { useState } from "react";
import { Modal } from "react-bootstrap";

const RegisteredEmpCT = () => {
  const [showModal, setShowModal] = useState(false);
  const [limitExtend, setLimitExtend] = useState("");
  const [getLimitExtend, setGetLimitExtend] = useState(null);

  const limitExtendChange = (event) => setLimitExtend(event.target.value);

  const handleSubmit = (newLimit) => {
    // Your logic for handling the submission
    console.log("Limit Extended to:", newLimit);
    setShowModal(false);
  };

  return (
    <div className="p-3">
      <div>
        <ul className="nav nav-tabs-CT" id="myTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active tab-item"
              id="registered-corporates-tab"
              data-bs-toggle="tab"
              data-bs-target="#registered-corporates"
              type="button"
              role="tab"
              aria-controls="registered-corporates"
              aria-selected="true"
            >
              Registered Employer
            </button>
          </li>
        </ul>

        <div className="tab-content mt-3" id="myTabsContent">
          <div
            className="tab-pane fade show active"
            id="registered-corporates"
            role="tabpanel"
            aria-labelledby="registered-corporates-tab"
          >
            <div className="pt-3">
              <div className="card">
                <div className="p-3 pt-4">
                  <div className="table-responsive">
                    <table className="table table-striped mt-3">
                      <thead>
                        <tr>
                          <th style={{ textAlign: "center" }}>Sr. No</th>
                          <th style={{ textAlign: "center" }}>Name</th>
                          <th style={{ textAlign: "center" }}>LID</th>
                          <th style={{ textAlign: "center" }}>Mobile</th>
                          <th style={{ textAlign: "center" }}>
                            Limit Assigned
                          </th>
                          <th style={{ textAlign: "center" }}>Limit Used</th>
                          <th style={{ textAlign: "center" }}>Status</th>
                          <th style={{ width: "150px", textAlign: "center" }}>
                            Extend Limit
                          </th>
                        </tr>
                      </thead>
                      {/* <tbody>
                      {empDetails &&
                        empDetails.length > 0 &&
                        empDetails.map((detail, index) => (
                          <tr key={index}>
                            <td style={{ textAlign: "center" }}>{index + 1}</td>
                            <td style={{ textAlign: "center" }}>{detail.name}</td>
                            <td
                              style={{
                                textAlign: "center",
                                color: "blue",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                if (detail.lid) {
                                  setLid(detail.lid);
                                  setShowSearch(true);
                                }
                              }}
                            >
                              {detail.lid}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {detail.mobile}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {detail.limitassigned}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {detail.limitused}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {detail.status || "N/A"}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              <button
                                className="btn btn-success"
                                style={{ width: "100px" }}
                                onClick={() => {
                                  setShowModal(true);
                                  setLimitExtend(detail.limitassigned);
                                }}
                              >
                                Extend
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody> */}
                    </table>

                    {/* Modal for extending the limit */}
                    <Modal
                      show={showModal}
                      onHide={() => setShowModal(false)}
                      style={{ background: "rgb(255 255 255 / 40%)" }}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Limit Extend</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <input
                          type="number"
                          value={limitExtend}
                          onChange={limitExtendChange}
                          style={{
                            width: "100%",
                            padding: "10px",
                            boxSizing: "border-box",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            marginTop: "10px",
                            fontSize: "18px",
                          }}
                        />
                        <div className="d-flex mt-3 justify-content-end">
                          <button
                            className="btn btn-secondary"
                            style={{ width: "100px" }}
                            onClick={() => setShowModal(false)}
                          >
                            Cancel
                          </button>
                          <button
                            className="btn btn-success ml-2"
                            style={{
                              width: "100px",
                              background: "black",
                              color: "white",
                            }}
                            onClick={() => handleSubmit(limitExtend)}
                          >
                            Submit
                          </button>
                        </div>
                      </Modal.Body>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisteredEmpCT;
